import {Pipe, PipeTransform} from "@angular/core";
import {DelayLevel, DelayLevelType} from "../models/delay-level.model";

@Pipe({name: 'delayTooltip', standalone: true, pure: true})
export class DelayTooltipPipe implements PipeTransform {
    public transform(delayType: DelayLevelType): string {
        switch (delayType) {
        case DelayLevel.ShortDelay:
            return 'LOW_DELAY_TOOLTIP';
        case DelayLevel.MediumDelay:
            return 'MEDIUM_DELAY_TOOLTIP';
        default:
            return 'SEVERE_DELAY_TOOLTIP';
        }
    }
}
